export const homeBanners = [
  {
    id: "b1",
    workId: "t-04",
    kicker: "本季科幻强档",
    headline: "宇宙边疆",
    description: "人类边境星陷入资源危机，一支舰队驶向未知深空，寻找文明得以延续的第二家园。",
  },
  {
    id: "b2",
    workId: "m-02",
    kicker: "口碑古装悬疑",
    headline: "长安夜雨",
    description: "长安夜雨连绵，一桩灭门旧案被重新翻开，书生卷入朝堂暗流，步步惊心。",
  },
  {
    id: "b3",
    workId: "t-01",
    kicker: "热播权谋大剧",
    headline: "长风渡月",
    description: "没落世家女与寒门谋士携手入局，从棋局之子走到执棋之人。",
  },
  {
    id: "b4",
    workId: "m-01",
    kicker: "硬核太空冒险",
    headline: "星际归途",
    description: "飞船被卷入未知虫洞，宇航员必须在燃料耗尽前找到归途。",
  },
  {
    id: "b5",
    workId: "v-07",
    kicker: "震撼自然纪录片",
    headline: "自然探索者",
    description: "深入地球最隐秘的角落，记录罕见生灵的生存故事与自然的壮阔变迁。",
  },
];